import { httpClient } from "@/services";

export default {
	state: {
		statisticsData: null,
		workOrdersStatisticsList: null,
		workOrdersStatisticsFilter: null,
		workOrdersStatisticsInfo: null,
	},
	mutations: {
		updateWorkOrdersStatistics(state, payload) {
			state.statisticsData = payload;
		},
		updateWorkOrdersStatisticsList(state, { workOrder, filter, ...obj }) {
			state.workOrdersStatisticsList = workOrder;
			state.workOrdersStatisticsFilter = filter;
			state.workOrdersStatisticsInfo = obj;
		}
	},
	actions: {
		async onWorkOrdersStatistics({ commit }) {
			try {
				const { data } = await httpClient.get('/work-order/statistics');
				if (data && !data.status) {
					commit('updateWorkOrdersStatistics', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onWorkOrdersStatisticsFilter({ commit }, { currentDate, ...filters }) {
			try {
				const { data } = await httpClient.post(`/work-order/statistics/show/${ currentDate }`, filters);
				if (data && !data.status) {
					commit('updateWorkOrdersStatisticsList', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onWorkOrdersStatisticsEdit({ commit }, values) {
			try {
				const { data } = await httpClient.post('/work-order/statistics/list', values);
				if (data && !data.status) {
					commit('updateWorkOrdersStatistics', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onWorkOrdersStatisticsInfo({ commit }, { date, values }) {
			try {
				const { data } = await httpClient.post(`work-order/statistics/show/${ date }`, values);
				if (data && !data.status) {
					commit('updateWorkOrdersStatisticsList', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
	},
	getters: {
		statisticsData: s => s.statisticsData,
		workOrdersStatisticsInfo: s => s.workOrdersStatisticsInfo,
		workOrdersStatisticsFilter: s => s.workOrdersStatisticsFilter,
		workOrdersStatisticsList: s => s.workOrdersStatisticsList
	}
};
